(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-pepita-countdown]:not([data-ready])').forEach(bar => {
      bar.dataset.ready = 'true';
      const end = Date.parse(bar.dataset.deadline);
      const tick = () => {
        if (!bar.isConnected) return false;
        const left = Math.floor((end - Date.now()) / 1000);
        if (!Number.isFinite(left) || left <= 0) { bar.remove(); return false; }
        [['days', Math.floor(left / 86400)], ['hours', Math.floor(left / 3600) % 24], ['minutes', Math.floor(left / 60) % 60], ['seconds', left % 60]].forEach(([key,value]) => { bar.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0'); });
        return true;
      };
      if (tick()) { const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000); }
    });
    root.querySelectorAll('[data-pepita-offers]:not([data-ready])').forEach(strip => {
      strip.dataset.ready = 'true';
      const items = [...strip.querySelectorAll('[data-offer-item]')];
      if (!items.length) return;
      let index = 0, paused = reduced.matches;
      const show = () => { items.forEach((item,i) => item.classList.toggle('is-active', i === index)); };
      strip.querySelector('.pepita-offer-line').classList.add('is-ready'); show();
      const button = strip.querySelector('[data-offer-pause]');
      button.addEventListener('click', () => { paused = !paused; button.setAttribute('aria-pressed', String(paused)); button.textContent = paused ? '▶' : 'Ⅱ'; });
      const timer = setInterval(() => { if (!strip.isConnected) return clearInterval(timer); if (paused || strip.matches(':hover') || strip.contains(document.activeElement)) return; index = (index + 1) % items.length; show(); }, 4500);
    });
    root.querySelectorAll('[data-pepita-gallery]:not([data-ready])').forEach(gallery => {
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.pepita-video-track');
      gallery.querySelectorAll('[data-video-direction]').forEach(button => button.addEventListener('click', () => track.scrollBy({left:Number(button.dataset.videoDirection) * track.clientWidth * .8, behavior:reduced.matches ? 'instant' : 'smooth'})));
      gallery.querySelectorAll('video').forEach(video => video.addEventListener('play', () => gallery.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
    });
    root.querySelectorAll('[data-pepita-purchase]').forEach(box => updateStock(box));
  }
  function updateStock(box, variantId) {
    const data = JSON.parse(box.querySelector('[data-pepita-stock-data]').textContent);
    const variant = data.variants.find(v => String(v.id) === String(variantId || data.selected));
    if (!variant) return;
    const state = variant.tracked && variant.quantity <= 0 && variant.policy === 'continue' ? 'backorder' : !variant.available ? 'sold' : variant.tracked && variant.quantity > 0 && variant.quantity <= 5 ? 'low' : 'available';
    const label = box.querySelector('[data-pepita-stock]'); label.textContent = data.messages[state]; label.dataset.level = state;
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-pepita-guide-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.pepitaGuideOpen);
      const product = trigger.closest('product-info') || document;
      const source = product.querySelector('[data-lunea-size-guide]') || product.querySelector('.product__description table');
      const target = dialog.querySelector('[data-pepita-measure-table]'); target.replaceChildren();
      if (source) { const clone = source.cloneNode(true); clone.removeAttribute('id'); clone.querySelectorAll('[id]').forEach(n => n.removeAttribute('id')); target.append(clone); }
      dialog.querySelector('[data-pepita-measure-missing]').hidden = Boolean(source); dialog.showModal();
    }
    if (event.target.closest('[data-pepita-guide-close]')) event.target.closest('dialog').close();
    if (event.target.matches('.pepita-measure-dialog')) { const r = event.target.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close(); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, event => { document.querySelectorAll('[data-pepita-purchase]').forEach(box => updateStock(box, event.data?.variant?.id)); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
